var _rect, _path, _path2, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.2981,
    y: 16.9665,
    width: 7.63492,
    height: 13.5732,
    fill: "#65D6AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3597 4.2417L25.8353 8.54048C25.8353 8.54048 28.1519 11.0118 28.843 16.0665C29.534 21.1212 28.843 30.5398 28.843 30.5398H20.3597V4.2417Z",
    fill: "#27AB83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4215 0H16.9665V3.3932H18.6632V5.93816H19.5115V16.9665H21.2082V30.5397H18.6632V30.5396H11.0283V5.93816H12.7249V3.3932H14.4215V0Z",
    fill: "#65D6AD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.0899,
    y: 9.3316,
    width: 7.63492,
    height: 21.2081,
    fill: "#3EBD93"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 14.4216,
    width: 7.63492,
    height: 16.1182,
    fill: "#27AB83"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.de517c3acf8d4a76e66cc588a3c2c046.svg";
export { ForwardRef as ReactComponent };